<div edlFocusTrap class="focus-trap-container">
<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-sm-12">
            <fieldset>
                <legend class="visually-hidden">{{title}}</legend>
                <ul class="row">
                    <li class="col-sm-4" *ngFor="let group of filteredGroups">
                        <div class="test">
                            <label class="form-label">
                                <input type="checkbox"
                                       [(ngModel)]="group.IsSelected"
                                       [ngModelOptions]="{ standalone: true }"
                                       [value]="group.GroupID"/>
                                {{ group.GroupName }}
                            </label>
                        </div>
                    </li>
                </ul>
                <hr>
                <div class="col-sm-12">
                    <button type="button" class="btn btn-link" (click)="selectalll()">Select All</button> | <button type="button" class="btn btn-link" (click)="deselectalll()">Deselect All</button>
                  </div>
            </fieldset>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="ok()">Ok</button>
    <button type="button" class="btn btn-info" (click)="cancel()">Cancel</button>
</div>
</div>